<div class="component-wrapper">
    <ng-container *transloco="let t">
        <h2 class="heading">{{ t('buy-product-with-zdorovi', { name: heading }) }}</h2>
    </ng-container>
    <div class="steps-container">
        <div class="step" *ngFor="let item of items; let i = index;">
            <div class="left">
                <img class="image" [alt]="item.heading" [src]="imagesPath[i]">
            </div>
            <div class="right">
                <span class="step-index">{{ 'step' | transloco }} №{{ i + 1 }}</span>
                <p class="right-heading">{{ item.heading }}</p>
                <p class="text">{{ item.text }}</p>
            </div>
        </div>
    </div>
</div>